import { api } from '@setplex/tria-api'
import { createEvent, restore, sample } from 'effector'
import { not } from 'patronum'
import { register } from '~/core/repository'
import { model as tvShowBundleModel } from '~/entities/shows/bundles'
import { genPagesLogicNew } from '~/shared/effector'
import { nay, T } from '~/shared/helpers'

// *
// * EVENTS
// *

export const initShowsBundlePage = createEvent<{
  bundleId: number
  query: URLSearchParams
}>()
export const left = createEvent()

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

/** Skeleton end*/

// *
// * CONNECTIONS
// *

// vod
sample({
  clock: initShowsBundlePage,
  filter: not(api.showBundles.loadShowBundleWithContentFx.pending),
  fn: (clockData) => ({ ...clockData, page: 0 }),
  target: api.showBundles.loadShowBundleWithContentFx,
})

/********** Skeleton logics starts ***********/

sample({
  clock: initShowsBundlePage,
  fn: T,
  target: setContentLoading,
})

sample({
  clock: api.showBundles.loadShowBundleWithContentFx.pending,
  filter: nay,
  target: setContentLoading,
})

/********** Skeleton logics ends ***********/

export const loadMoreShowBundleContent = genPagesLogicNew(
  api.showBundles.$showBundleWithContentPageInfo,
  api.showBundles.paginateShowBundleWithContent
)

// *
// * STORES
// *

// clear paginatable stores
api.showBundles.$showBundleWithContent.reset(initShowsBundlePage)

register(loadMoreShowBundleContent, 'loadMoreShowBundleContent')
register(
  tvShowBundleModel.$showBundleWithContentFormatted,
  '$showBundleWithContent'
)
